/// <reference path="../../app.definition.ts" />

//module eCareVault {
    angular.module('eCareVault.common.factory')
        .factory('$moment', ['$window',($window: ng.IWindowService) => $window.moment || window.moment || null]);
//}
